/**
 * Build-time application version.
 *
 * `vite.config.ts` and `vitest.config.ts` both read the repository `VERSION`
 * file and inject it as `import.meta.env.VITE_APP_VERSION`. There is no
 * fallback: a build without a version fails rather than shipping a wrong one.
 */
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION;
